import React from "react";
import moment from "moment";
import { Modal, Card, Row, Typography, Tooltip, Button } from "antd";
import PropTypes from "prop-types";
import "./StartMCQ.modal.css";
import { withStyles } from "@material-ui/core/styles";
import roundCheck from "../../../../assets/img/round-check_circle-24px.svg";
import { ClockIcon } from "../../../components/common/CustomIcon";

const { Title } = Typography;

const useStyles = (theme) => ({
  roundCheck: {
    width: "18px",
    height: "18px",
    background:
      "transparent url(" +
      roundCheck +
      ") 0% 0% no-repeat padding-box !important",
    opacity: "1",
  },

  completedButton: {
    border: "none",
    color: "#66CC80",
    width: "84px",
    height: "36px",
    padding: "0px",
    pointerEvent: "none",
    letterSpacing: "0.56px",
    textDecoration: "none",
    outline: "none",
    fontSize: "0.9em",
  },

  buttonItemSpacing: {
    marginLeft: "10px",
    textAlign: "right",
  },

  medianMCQTime: {
    textAlign: "left",
    font: "Regular 12px/16px",
    letterSpacing: "0px",
    color: "#AAAAAA",
    opacity: 1,
  },
});

function StartASAModal(props) {
  const { isOpen, onClose, onStart } = props;

  return (
    <Modal
      visible={isOpen}
      onCancel={onClose}
      footer={null}
      width="488px"
      className="turing-ui-v2-mcq-modal"
      bodyStyle={{ padding: 0, margin: 0 }}
      destroyOnClose
      centered
    >
      {isOpen ? (
        <div className="turing-ui-v2-start-mcq-modal-container">
          <Card className="details-card">
            <div className="turing-ui-v2-start-mcq-modal-title">
              <Title level={4}>Work Experience Survey</Title>
            </div>
            {/* {activeItem.recommended ? (
              <div className="turing-ui-v2-recommended">Recommended based on your<br /> Work History and skills</div>
            ) : null} */}
            <div className="challenge-description">
              Complete our Work Experience Survey to declare your seniority
              level, past roles, and role preferences to let us suggest you for
              the right jobs . Click 'Start Survey' to get started.
            </div>
            <div className="turing-ui-v2-start-mcq-modal-actions ">
              <span className="timeEstimate">
                <ClockIcon />
                Estimated Time 15 min
              </span>
              <StartButton
                proceed={onStart}
              />
            </div>
          </Card>
        </div>
      ) : null}
    </Modal>
  );
}

const StartButton = ({ proceed }) => {
  const startTestBtn = (
    <Button
      icon="caret-right"
      type="primary"
      onClick={proceed}
    >
      Start Quiz
    </Button>
  );

  return (
    <Row className="start-button-actions">
      {startTestBtn}
    </Row>
  );
};

StartButton.propTypes = {
  proceed: PropTypes.func
};

StartASAModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onStart: PropTypes.func
};

export default withStyles(useStyles)(StartASAModal);
